import { createContext } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

const CartContext = createContext();

const fetchCart = () => {
  const storedCart = localStorage.getItem("cart");
  return storedCart ? JSON.parse(storedCart) : [];
};

const CartProvider = ({ children }) => {
  const queryClient = useQueryClient();

  const { data: cart = [],refetch } = useQuery({
    queryKey: ["cart"],
    queryFn: fetchCart,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const updateCart = (updatedCart) => {
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    queryClient.setQueryData(["cart"], updatedCart);
  };

  const addToCart = (product) => {
    const existing = cart.find(item => item.product_id === product.product_id);

    if (existing) {
      const updatedCart = cart.map(item =>
        item.product_id === product.product_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      updateCart(updatedCart);
      toast.success("Quantity updated");
      refetch()
    } else {
      const newItem = { ...product, quantity: 1 };
      updateCart([...cart, newItem]);
      toast.success("Product added to cart");
      refetch()
    }
  };

  const removeFromCart = (id) => {
    const updatedCart = cart.filter((item) => item.product_id !== id);
    updateCart(updatedCart);
    toast.success("Product removed");
  };

  const increment = (id) => {
    const item = cart.find((i) => i.product_id === id);
    if (item.quantity >= 15) return toast.error("Maximum Order Quantity 15");

    const updatedCart = cart.map((item) =>
      item.product_id === id
        ? { ...item, quantity: item.quantity + 1 }
        : item
    );
    updateCart(updatedCart);
  };

  const decrement = (id) => {
    const item = cart.find((i) => i.product_id === id);
    if (item.quantity <= 1) return toast.error("Minimum order quantity is 1");

    const updatedCart = cart.map((item) =>
      item.product_id === id
        ? { ...item, quantity: item.quantity - 1 }
        : item
    );
    updateCart(updatedCart);
  };
  const removeCart = async() =>{
     localStorage.removeItem("cart")
     refetch()
    
  }

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, increment, decrement ,removeCart,refetch}}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext, CartProvider };
